import * as Sentry from "@sentry/react"
import { BrowserTracing } from "@sentry/tracing"

Sentry.init({
  dsn: "https://0cc2047506ec7655222d36e76c26518b@sentry.betfolio.io/2",
  integrations: [new Sentry.Replay()],
  environment: process.env.NODE_ENV,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
})